import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Renderer2 } from '@angular/core';
import { ApiService } from '../api.service';
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit, AfterViewInit {
	user: any = { email: '', password: '' };
	year: number = new Date().getFullYear();
	ScreenHeight: number = window.innerHeight;
	loadershow: boolean = false;
	loginErrorshow: boolean = false;
	loginFormErr: string = "";
	adminAccess: any;
	data: any = null;
	step: number = 1;
	showQR = false;
	qrToShow: any;
	auth: any = { otp: null };
	qrStep = 1;

	constructor(private apiService: ApiService, private router: Router, private renderer: Renderer2, private toastr: ToastrService, private route: ActivatedRoute,) { }

	ngAfterViewInit(): void { }

	ngOnInit(): void {
		if (localStorage.getItem('simulation_token') != null && localStorage.getItem('simulation_token') != undefined) {
			this.gotoDashboard();
		}
	}

	submitForm(user: any) {
		this.loadershow = true;
		this.apiService.loginAPI(user).subscribe({
			next: (data: any) => {
				this.loadershow = false;
				this.data = data;
				this.proceedLogin();
				/* if (this.data.enable2fa && this.data.first_login) {
					this.step = 2;
					this.showQR = true;
					this.generateQR();
				} else if (this.data.enable2fa && !this.data.first_login) {
					this.step = 2;
					this.showQR = false;
					this.qrStep = 2;
				} else {
					this.proceedLogin();
				} */
			}, error: (error: any) => {
				this.loadershow = false;
				this.loginErrorshow = true;
				this.loginFormErr = "Username Or Password is incorrect.";
				setTimeout(() => {
					this.loginErrorshow = false;
				}, 5000);
			}
		});
	}

	next() {
		this.qrStep = 2;
	}

	generateQR() {
		this.loadershow = true;
		let data: any = {
			id: this.data.main_user,
			user: this.data.emailId
		};
		this.apiService.generate_qr(data).subscribe({
			next: (data: any) => {
				this.loadershow = false;
				this.createImageFromBlob(data);
			}, error: (error: any) => {
				this.loadershow = false;
				this.loginErrorshow = true;
				this.loginFormErr = "Something went wrong";
				setTimeout(() => {
					this.loginErrorshow = false;
				}, 5000);
			}
		});
	}

	createImageFromBlob(image: Blob) {
		let reader = new FileReader();
		reader.addEventListener("load", () => {
			this.qrToShow = reader.result;
		}, false);
		if (image) {
			reader.readAsDataURL(image);
		}
	}

	verifyOTP() {
		if (!this.auth.otp) {
			this.toastr.warning("Please enter OTP", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		this.loadershow = true;
		let data: any = {
			id: this.data.main_user,
			otp: this.auth.otp
		};
		this.apiService.verifyGoogleAuthOTP(data).subscribe({
			next: (data: any) => {
				this.loadershow = false;
				this.proceedLogin();
			}, error: (error: any) => {
				this.loadershow = false;
				this.loginErrorshow = true;
				this.loginFormErr = "Invalid OTP";
				setTimeout(() => {
					this.loginErrorshow = false;
				}, 5000);
			}
		});
	}

	proceedLogin() {
		localStorage.setItem('simulation_token', "Bearer " + this.data["token"]);
		localStorage.setItem('simulation_refresh_token', this.data["refreshtoken"]);
		localStorage.setItem("name", `${this.data["firstName"]} ${this.data["lastName"]}`);
		this.gotoDashboard();
	}

	getLastParamValue(initialUrl: string, param: string): string | null {
		let current = initialUrl;
		let lastValue: string | null = null;
		while (true) {
			const dummy = new URL(current, 'http://dummy');
			const value = dummy.searchParams.get(param);
			if (!value) break;
			lastValue = value;
			current = decodeURIComponent(value);
		}
		return lastValue;
	}


	gotoDashboard() {
		let returnUrl = this.getLastParamValue(this.route.snapshot.queryParams['returnUrl'], 'returnUrl') || this.apiService.getHomeURL();
		this.router.navigate([returnUrl]);
		/* this.router.navigate([this.apiService.getHomeURL()]); */
	}
}
